import { useMemo } from 'react'

import type { FlightsClassTypes } from 'constants/flight'
import useCharterDateRangesByMonth from 'hooks/CharterFlights/useCharterDateRangesByMonth'
import { MALDIVES_CHARTER_ROUTE } from 'api/lib/flightDealMap'

import { getCheapestCalendarBundleData } from '../utils/bundlePricingDisplay'
import { filterDateRangesByNights } from './utils'
import { useMaldivesDirectCalendarPricing } from './useMaldivesDirectCalendarPricing'

interface Params {
  checkInDate?: string
  occupancies: Array<App.Occupants>
  fareClass: FlightsClassTypes
  nights: number
  luxPlusEnabled: boolean
  feederOriginAirportCode?: string
}

export function useMaldivesCharterFareClassBundleData({
  checkInDate,
  occupancies,
  fareClass,
  nights,
  luxPlusEnabled,
  feederOriginAirportCode,
}: Params) {
  const { dateRangesByMonth: allDateRangesByMonth } = useCharterDateRangesByMonth({
    charterBundleRoute: MALDIVES_CHARTER_ROUTE,
    occupancies,
    fareClass,
    feederOriginAirportCode,
  })
  const dateRangesByMonth = useMemo(
    () => filterDateRangesByNights(allDateRangesByMonth, nights),
    [allDateRangesByMonth, nights],
  )
  const { calendarPricingByDate, isLoading } = useMaldivesDirectCalendarPricing({
    rooms: occupancies,
    fareClass,
    selectedFareClass: fareClass,
    nights,
    charterBundleRoute: MALDIVES_CHARTER_ROUTE,
    dateRangesByMonth,
    feederOriginAirportCode,
  })
  const bundleData = useMemo(() => {
    return checkInDate ?
      calendarPricingByDate[checkInDate] :
        getCheapestCalendarBundleData(calendarPricingByDate, { useMemberPrice: luxPlusEnabled, priceMode: 'total' })
  }, [calendarPricingByDate, checkInDate, luxPlusEnabled])

  return {
    bundleData,
    isLoading,
  }
}
